import { Injectable, EventEmitter } from '@angular/core';
import { ICredentialModel, IToken } from '../../models/account/account-models';
import { StorageService } from '../storage.service';
import { ApiService } from '../data/api.service';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { SecuritySettingsModel } from '../../models/security/security-settings.model';
interface IAuthService {
    isLoggedIn: boolean;
}

@Injectable()
export class AuthService implements IAuthService {
    //private tokeyKey = "token";
    //private token: string | null;
    public error: any;
    public hasError: boolean;
    public hasUserLoggedIn: boolean;
    public TName: string
    public userModel: ICredentialModel;
    public isLoggedIn$: EventEmitter<boolean>;
    constructor(private apiService: ApiService, private storageService: StorageService) {
        this.isLoggedIn$ = new EventEmitter();
    }
    get isLoggedIn(): boolean {
        let token = this.storageService.get<IToken>(SecuritySettingsModel.access_token);
        if (token && token !== null)
            return true;

        return false;
    }
    public login(data: ICredentialModel): Promise<IToken> {
        return this.apiService.post("api/auth/login", data)
            .toPromise()
            .then((response: IToken) => {
                this.hasUserLoggedIn = true;
                this.hasError = false;
                //deferred.resolve((response.data) as IToken);
                this.storageService.save<IToken>(SecuritySettingsModel.access_token, response);
                this.isLoggedIn$.emit(true);
                return response;
            });
    }
    /*authPost(url: string, body: any): Promise<ErrorObservable | RequestResult> {
        //let headers = this.initAuthHeaders();
        return this.apiService.post(url, body, { headers: headers });
            //.map(response =>  return response);
            //.catch(this.handleError);
    }

    authGet(url: string): Promise<ErrorObservable | RequestResult> {
        let headers = this.initAuthHeaders();
        return this.http.get(url, { headers: headers }).toPromise()
            .then((response: Response) => response.json() as RequestResult)
            .catch(this.handleError);
    }

    private getLocalToken(): string | null {
        if (!this.token) {
            this.token = sessionStorage.getItem(this.tokeyKey);
        }
        return this.token;
    }

    private initAuthHeaders(): Headers {
        let token = this.getLocalToken();
        if (token == null) throw "No token";

        var headers = new Headers();
        headers.append("Authorization", "Bearer " + token);

        return headers;
    }*/

    private handleError(error: Response) {
        console.error('An error occurred', error);
        this.hasError = true;
        this.error = error;
        let msg = `Status Code ${error.status} on url ${error.url}`;
        console.error(msg);
        return throwError(() => error);
    }
    public logout(): Promise<any> {
        return this.apiService.post("api/auth/Logout", "").toPromise()
            .then((response: Response) => {
                this.isLoggedIn$.emit(false);
                return response;
            });
    }
}